var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRecord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{clip-path:url(#SVGID_00000007412441659868632940000000397148593653691558_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    d: "M50,7.9v5.26h-7.89v7.89h-5.26v-7.89h-7.9V7.91h7.89V0h5.26V7.9H50z M42.11,44.74H5.26V7.9h15.79V2.64H5.26 C2.36,2.65,0.01,5,0,7.9v36.84c0.01,2.9,2.36,5.25,5.26,5.26h36.85c2.9-0.01,5.25-2.36,5.26-5.26V28.95h-5.26V44.74z M31.58,28.95 v10.53h5.26V28.95L31.58,28.95z M21.05,39.48h5.26V18.42h-5.26V39.48z M15.8,39.48V23.69h-5.26v15.79H15.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecord);
export default __webpack_public_path__ + "static/media/Icon_Record.ad4202acfb4329de300e55c3b7c38f0b.svg";
export { ForwardRef as ReactComponent };